(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  const cache = {};
  let done = false;

  async function getProduct(handle) {
    if (cache[handle] !== undefined) return cache[handle];
    try {
      const res = await fetch('/products/' + handle + '.js');
      cache[handle] = res.ok ? await res.json() : null;
    } catch (e) {
      cache[handle] = null;
    }
    return cache[handle];
  }

  function currentHandle() {
    const m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function currentVariantId(viewed) {
    const v = new URL(window.location.href).searchParams.get('variant');
    if (v) return parseInt(v, 10);
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return parseInt(input.value, 10);
    return viewed && viewed.variants.length ? viewed.variants[0].id : null;
  }

  function optionNames(p) {
    return p.options.map(o => (typeof o === 'string') ? o : o.name);
  }

  function wantedMap(viewed, variantId) {
    const variant = viewed.variants.find(v => v.id === variantId) || viewed.variants[0];
    const names = optionNames(viewed);
    const map = {};
    names.forEach((n, i) => { map[n] = variant.options[i]; });
    return map;
  }

  function bestVariant(rel, want) {
    const names = optionNames(rel);
    let best = null, bestScore = 0;
    rel.variants.forEach(v => {
      let score = 0;
      names.forEach((n, i) => {
        if (want[n] !== undefined && want[n] === v.options[i]) score++;
      });
      if (score > bestScore || (score === bestScore && score > 0 && best && v.price < best.price)) {
        bestScore = score; best = v;
      }
    });
    return bestScore > 0 ? best : null;
  }

  function applyToSwiper(swiper, id, tries) {
    if (!swiper) return;
    swiper.dataset.defaultVariantId = id;
    if (swiper.allSlides && typeof swiper.filterByVariant === 'function') {
      swiper.filterByVariant(id, false);
    } else if ((tries || 0) < 60) {
      requestAnimationFrame(() => applyToSwiper(swiper, id, (tries || 0) + 1));
    }
  }

  async function apply() {
    const container = document.querySelector('product-recommendations');
    if (!container) return;
    const cards = container.querySelectorAll('product-card[handle]');
    if (!cards.length) return;

    const viewed = await getProduct(currentHandle());
    if (!viewed) return;
    const want = wantedMap(viewed, currentVariantId(viewed));

    for (const card of cards) {
      const rel = await getProduct(card.getAttribute('handle'));
      if (!rel) continue;
      const match = bestVariant(rel, want);
      if (!match) continue;

      applyToSwiper(card.querySelector('product-card-swiper'), match.id);

      card.querySelectorAll('a[href*="/products/"]').forEach(a => {
        try {
          const u = new URL(a.href, window.location.origin);
          u.searchParams.set('variant', match.id);
          a.setAttribute('href', u.pathname + u.search);
        } catch (e) {}
      });
    }
  }

  function tryInitial() {
    const c = document.querySelector('product-recommendations');
    if (!done && c && c.querySelector('product-card[handle]')) {
      done = true;
      obs.disconnect();
      apply();
    }
  }

  const obs = new MutationObserver(tryInitial);
  obs.observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') tryInitial();
  else document.addEventListener('DOMContentLoaded', tryInitial);

  document.addEventListener('change', (e) => {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) {
      setTimeout(apply, 60);
    }
  });
  window.addEventListener('popstate', () => setTimeout(apply, 60));
})();